import { Building2, PartyPopper, Trophy, GraduationCap, User } from "@/components/Icon";

const audiences = [
  { icon: Building2, label: "Bedrijven & bedrijfskleding" },
  { icon: PartyPopper, label: "Evenementen" },
  { icon: Trophy, label: "Sportverenigingen & teams" },
  { icon: GraduationCap, label: "Scholen & instellingen" },
  { icon: User, label: "Particulieren" },
];

const ForWhom = () => (
  <section className="py-20 md:py-28">
    <div className="container">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2933]">
          Voor wie bedrukken wij kleding?
        </h2>
        <p className="text-muted-foreground">
          Magic Print verzorgt het bedrukken en borduren van kleding voor verschillende soorten klanten in Den Haag en heel Nederland.
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-6">
        {audiences.map((a) => (
          <div
            key={a.label}
            className="flex items-center gap-3 bg-card border border-border rounded-2xl px-6 py-4 hover:border-primary/40 hover:shadow-md transition-all"
          >
            <a.icon className="w-6 h-6 text-primary flex-shrink-0" />
            <span className="font-medium text-sm">{a.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ForWhom;
